import { useAppSelector } from 'store/hook';
import { isDarkTheme } from 'utils/theme';
import { type Asset } from 'types/asset.types';
import { useEffect, useState } from 'react';
import Header from './Header';
import MainBody from './MainBody';
import { getAssetMakeModel } from 'views/FleetOverview/components/AssetCardsV2/utils';
import { composeUniqueKey } from 'utils/helpers/string.manipulation';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezone);

const VirtualLoadTest = () => {
  const { latestTagData } = useAppSelector((state) => state.deviceReducer);
  const hierarchyInfo = useAppSelector((state) => state.hierarchyReducer);
  const theme = useAppSelector((state) => state.authReducer).customer.theme;
  const enableDarkTheme = isDarkTheme(theme);

  const { assets } = useAppSelector((state) => state.assetReducer);

  const defaultAsset: string | null = new URLSearchParams(location.search).get(
    'asset'
  );
  const makeModels = getAssetMakeModel(assets);

  const [selectedMakeModel, setSelectedMakeModel] = useState(() => {
    if (makeModels.length > 0) {
      return makeModels[0];
    } else {
      return '';
    }
  });
  const [assetBumperIds, setAssetBumperIds] = useState<string[]>([]);

  const [selectedAsset, setSelectedAsset] = useState<Asset | null>(null);

  const handleSelectAsset = (bumperNumber: string) => {
    const item = assets.find((asset) => asset.bumperNumber === bumperNumber);
    if (item) {
      setSelectedAsset(item);
    }
  };

  useEffect(() => {
    const filteredAssets = assets
      ?.filter(
        (asset) =>
          composeUniqueKey([asset.make, asset.model]) ===
          selectedMakeModel.replace('-', '!')
      )
      .map((item) => {
        return item.bumperNumber;
      })
      .sort((a, b) =>
        a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' })
      );
    setAssetBumperIds(filteredAssets);
    setSelectedAsset(
      assets.find((asset) => asset.bumperNumber === filteredAssets[0]) as Asset
    );
  }, [selectedMakeModel]);

  useEffect(() => {
    let assetDetails: Asset | undefined;

    if (defaultAsset) {
      assetDetails = assets.find((item) => item.bumperNumber === defaultAsset);
    } else {
      assetDetails = assets[0];
    }

    if (assetDetails) {
      const assetMakeModel = composeUniqueKey(
        [assetDetails?.make, assetDetails?.model],
        '-'
      );
      setSelectedAsset(assetDetails);
      setSelectedMakeModel(assetMakeModel);
    }
  }, [assets]);

  return (
    <>
      {selectedAsset && (
        <>
          <Header
            enableDarkTheme={enableDarkTheme}
            latestTagData={latestTagData}
            hierarchyInfo={hierarchyInfo}
            selectedAsset={selectedAsset}
            makeModels={makeModels}
            assetBumperIds={assetBumperIds}
            setSelectedAsset={handleSelectAsset}
            selectedMakeModel={selectedMakeModel}
            setSelectedMakeModel={setSelectedMakeModel}
          />
          <MainBody
            enableDarkTheme={enableDarkTheme}
            makeModel={`${selectedAsset?.make.toLowerCase()}${selectedAsset?.model.toLowerCase()}`}
            asset={selectedAsset}
          />
        </>
      )}
    </>
  );
};

export default VirtualLoadTest;
